import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../../config/Color';
import { useAppStore } from '../../../store/Store';
import { PricingSelector } from '../../../store/pricing/PricingActions';
import { Body } from '../../styles/Typography';
import { useDisclaimerText } from '../Disclaimer';
import { useCouponDiscount } from '../Header/Coupon';

/** The applied coupon, beside the prices it changes. A coupon for one payment says so. */
export const ComboDiscount: FunctionComponent = () => {
  const discount = useCouponDiscount();
  const isOneTime = useAppStore((state) => PricingSelector.hasOneTimeDiscount(state.pricing));
  if (discount === undefined) {
    return null;
  }
  return (
    <Discount data-test="couponDiscount">
      <svg
        viewBox="0 0 24 24"
        width={16}
        height={16}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L3 13V3h10l7.6 7.6a2 2 0 010 2.8z" />
        <circle cx="7.5" cy="7.5" r="1.5" />
      </svg>
      {`${discount} off your ${isOneTime ? 'first payment' : 'membership'}`}
    </Discount>
  );
};

/** Control's disclaimer, word for word, as a quiet card. */
export const ComboTerms: FunctionComponent = () => {
  const text = useDisclaimerText();
  if (text === undefined) {
    return null;
  }
  return (
    <TermsCard data-test="disclaimer">
      <Terms>{text.charge}</Terms>
      <Terms>{text.cancel}</Terms>
    </TermsCard>
  );
};

const Discount = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing._8px};
  margin: 0.5em 0;
  color: ${Color.content.onAccent};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const TermsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing._10px};
  margin-bottom: ${({ theme }) => theme.spacing._20px};
  padding: ${({ theme }) => theme.spacing._20px};
  border-radius: 20px;
  border: 0.6px solid ${Color.decorative.default};
  text-align: left;
`;

const Terms = styled(Body)`
  margin: 0;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.light};
  line-height: 1.5;
  color: ${Color.content.default};
`;
